import React from "react";
import { useState, useEffect } from "react";
import img1 from "../../assets/images/profile/orderImg1.png";
import img2 from "../../assets/images/profile/orderImg2.png";
import img3 from "../../assets/images/profile/orderImg3.png";
import img4 from "../../assets/images/profile/orderImg4.png";
import { styled } from "@mui/material/styles";
import CircleIcon from "@mui/icons-material/Circle";
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  Box,
} from "@mui/material";

const steps = [
  {
    label: "Order Confirmed",
    description: "Your order has been successfully confirmed",
  },
  {
    label: "Order Shipped",
    description: "Your order has been dispatched and is on its way",
  },
  {
    label: "Out for Delivery",
    description: "Your order is out for delivery and will arrive soon",
  },
  {
    label: "Delivered",
    description: "Your order has been delivered successfully",
  },
];

// Custom Step Icon to change default color
const GreenStepIcon = styled(CircleIcon)(({ theme }) => ({
  color: "#040325",
  fontSize: "14px",
}));

export function MyOrders() {
  const [cartproducts, setcartProduct] = useState([]);

  useEffect(() => {
    setcartProduct(cartproduct);
  }, []);

  var cartproduct = [
    {
      image: img1,
      name: "Classic Leather Shoes",
      subname: "EcoStep Shoes",
      details: "Size : 10 (UK)",
      price: 1200,
    },
    {
      image: img2,
      name: "Vintage Gold Locket",
      subname: "VintageVogue Jewelry",
      details: "Karat : 24",
      price: 40000,
    },
    {
      image: img3,
      name: "Radiant Silk Dress",
      subname: "RadiantRose Bridal",
      details: "Size : XL, Color : Peach",
      price: 1600,
    },
    {
      image: img4,
      name: "Stylish Ankle Boots",
      subname: "StyleTread Boots",
      details: "Size : 10 (UK)",
      price: 800,
    },
  ];

  return (
    <div className="myorder-container">
      <div className="myorder-subcontainer">
        <div className="orderHistory-container">
          <div className="orderTitle">Order History</div>
          <div className="orderHistory-item">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#040325" }}>#123456</span>
              <span style={{ color: "#357CFF" }}>In Progress</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#040325", fontWeight: "700" }}>₹1200</span>
              <span style={{ color: "#8E8CB2" }}>4 items</span>
            </div>
          </div>
          <div className="orderHistory-item">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#040325" }}>#123456</span>
              <span style={{ color: "#03751C" }}> Delivered</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#040325", fontWeight: "700" }}>₹1200</span>
              <span style={{ color: "#8E8CB2" }}>4 items</span>
            </div>
          </div>
          <div className="orderHistory-item">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#040325" }}>#123456</span>
              <span style={{ color: "#03751C" }}> Delivered</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#040325", fontWeight: "700" }}>₹1200</span>
              <span style={{ color: "#8E8CB2" }}>4 items</span>
            </div>
          </div>
          <div className="orderHistory-item">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#040325" }}>#123456</span>
              <span style={{ color: "#CF0808" }}>Cancelled</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#040325", fontWeight: "700" }}>₹1200</span>
              <span style={{ color: "#8E8CB2" }}>4 items</span>
            </div>
          </div>
        </div>
        <div className="myorder-ordersList">
          <div>Order:#123456</div>
          <div>
            {cartproducts.map((product) => (
              <div className="myorder-ordersRow">
                <div>
                  <img src={product.image} />
                </div>
                <div>
                  <div className="product-name">{product.name}</div>
                  <div className="product-subname">{product.subname}</div>
                  <div className="product-details">{product.details}</div>
                </div>
                <div className="product-prices">₹ {product.price}</div>
              </div>
            ))}
          </div>
          <div className="checkoutorder-summary">
            <div className="order-list">
              <div>Total Items</div>
              <div>4</div>
            </div>
            <div className="order-list">
              <div>Sub Total</div>
              <div>₹50000.00</div>
            </div>
            <div className="order-list">
              <div>Shipping</div>
              <div>₹100.00</div>
            </div>
            <div className="order-list">
              <div>Taxes</div>
              <div>₹0.00</div>
            </div>
            <div className="order-list">
              <div>Discount</div>
              <div className="text-success">₹1000.00</div>
            </div>
            <div className="productTotal">
              <div>Total</div>
              <div>₹49100.00</div>
            </div>
          </div>
          <div className="myorder-shippingContainer">
            <div>Shipping Details</div>
            <div className="shipping-field">
              <div>Name</div>
              <div>User Name</div>
            </div>
            <div className="shipping-field">
              <div>Phone Number</div>
              <div>+91 9876543210</div>
            </div>
            <div className="shipping-field">
              <div>Address</div>
              <div>123/45, Banjara hills..</div>
            </div>
            <div className="shipping-field">
              <div>Payment Mode</div>
              <div>Card</div>
            </div>
          </div>
          {/* tracking */}
          <div className="myorder-tracking">
            <div>Tracking Details</div>
            <div className="tracking-time">
              <div style={{ color: "#06043E" }}>Feb 12</div>
              <div style={{ color: "#8E8CB2" }}>3:30 p.m</div>
            </div>
            <Box sx={{ maxWidth: 400 }}>
              <Stepper orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={index} active>
                    <StepLabel
                      StepIconComponent={GreenStepIcon}
                      sx={{
                        color: "#06043E",
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      {step.label}
                    </StepLabel>
                    <StepContent>
                      <Typography
                        sx={{
                          color: "#8E8CB2",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        {step.description}
                      </Typography>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
}
